<template>
    <div>
        <div v-for="(phone, i) in phones">
            <div class="row mb-2">
                <div class="col-12 mb-1 input-group-sm">
                    <the-mask type="tel" :mask="'###-###-####'" v-model="phone.phone" :class="{'form-control': true, 'is-invalid': errors['phones.'+i+'.phone']}" placeholder="Enter Phone Number" />
                </div>
                <div class="col-12">
                    <v-select v-model="phone.phone_types" :options="phoneTypeOptions" :class="{'is-invalid': errors.phone_types}" :placeholder="`-- Select Phone Type(s) --`" multiple size="sm" />
                </div>
            </div>

            <div class="row mb-1">
                <div class="col-6">
                    <b-form-radio v-model="phone.is_primary" name="primary_phone" :value="1" :unchecked-value="0" v-on:change="selectPrimary(i)" plain><span>Primary</span></b-form-radio>
                </div>
                <div class="col-6 text-right">
                    <a href="javascript:void(0)" class="text-danger" v-on:click="deletePhone(i)"><i class="fa fa-trash"></i> Delete</a>
                </div>
            </div>

            <div class="text-danger mt-1" v-if="errors['phones.'+i+'.phone']">
                <ul class="list-unstyled mb-0">
                    <li v-for="err in errors['phones.'+i+'.phone']">{{ err }}</li>
                </ul>
            </div>

            <hr v-if="i < (phones.length - 1)" />
        </div>
    </div>
</template>

<script>
    import {TheMask} from 'vue-the-mask';

    export default {
        components: {TheMask},

        props: {
            phones: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                errors: {},
                is_primary: null,
            }
        },

        watch: {

        },

        computed: {
            phoneTypeOptions(){
                return [
                    'Residence',
                    'Business',
                    'Cell',
                    'Fax',
                ];
            },
        },

        methods: {
            addPhone(){
                //Push
                this.phones.push({phone: '', is_primary: 0, phone_type: null});
            },

            deletePhone(i){
                //Confirm
                if(!confirm('Are you sure you want to delete this phone: '+this.phones[i].phone))
                {
                    return;
                }

                //Splice
                this.phones.splice(i, 1);
            },

            getPhones(){
                //Set primary
                // for (var i = this.phones.length - 1; i >= 0; i--)
                // {
                //     if(this.phones[i].phone === this.is_primary)
                //     {
                //         this.phones[i].is_primary = 1;
                //     }
                //     else
                //     {
                //         this.phones[i].is_primary = 0;
                //     }
                // }

                //Get the phones
                return this.phones;
            },

            setErrors(errors){
                //Set the errors
                this.errors = errors
            },

            selectPrimary(index){
                //Radios only fire change on the selected one, so clear the rest
                for (var i = this.phones.length - 1; i >= 0; i--)
                {
                    this.phones[i].is_primary = i === index ? 1 : 0;
                }
            },

            setPrimary(){
                //Set primary
                for (var i = this.phones.length - 1; i >= 0; i--)
                {
                    if(this.phones[i].is_primary == 1)
                    {
                        this.is_primary = this.phones[i].phone;
                    }
                }
            },

        },

        mounted() {
            this.setPrimary();
        }
    }
</script>
